// @flow

import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useFocusable, FocusContext } from '@alphaott/smart-tv-spatial-navigation'
import { Loader } from '@alphaott/smart-tv-components'

import {
  Background,
  Container,
  Actions,
  Button,
  LoaderContainer,
} from './ContentUnavailableModal.styles'

const LoadingWrapper = ({ loading, children }) => {
  if (loading) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    )
  }

  return children
}

export type ContentUnavailableModalProps = {
  loading: boolean,
  html: any,
  onBack: () => void,
}

const scale = 1

export const ContentUnavailableModal = ({
  loading,
  html,
  onBack,
}: ContentUnavailableModalProps) => {
  const { ref, focusKey, setFocus } = useFocusable({ isFocusBoundary: true })
  const { t } = useTranslation()

  useEffect(() => {
    if (setFocus) {
      setFocus('GO_BACK_BUTTON_FOCUS_KEY')
    }
  }, [setFocus])

  return (
    <FocusContext.Provider value={focusKey}>
      <Background
        ref={ref}
        style={{
          fontSize: 22,
          transform: `scale(${scale})`,
          transformOrigin: 'top center',
        }}
      >
        <Container>
          <LoadingWrapper loading={loading}>
            <div
              /* eslint-disable-next-line react/no-danger */
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </LoadingWrapper>

          <Actions>
            <Button focusKey="GO_BACK_BUTTON_FOCUS_KEY" onClick={onBack}>
              {t('mwstv_go_back')}
            </Button>
          </Actions>
        </Container>
      </Background>
    </FocusContext.Provider>
  )
}

export default ContentUnavailableModal
